export const Default = () => ({

    benchmarkFiltersAnalysis: {
        date: {
            preset: "",
            customDateRange: []
        },
        surveys: [],
        raterGroups: []
    },

    fetchOrganizationConfigurationsApi: {
        isProcessing: false,
        error: false,
        reason: '',
        data: null,
    },

    updateOrgConfigurationsApi: {
        isProcessing: false,
        error: false,
        reason: '',
        data: null,
    },


    benchmarkFilters: {
        date: {
            preset: "",
            customDateRange: []
        },
        surveys: [],
        raterGroups: [
            'self',
            'manager',
            'direct report',
            'peer',
            "team member",
            "client",
            "cross-functional partner",
            'other'
        ]
    },


    fetchTotalFeedbackProvidersApi: {
        isProcessing: false,
        error: false,
        reason: '',
        data: null,
    },

    fetchTotalFeedbackProvidersStrengthAndDevApi: {
        isProcessing: false,
        error: false,
        reason: '',
        data: null,
    },


    fetchCantAnswerResponseApi: {
        isProcessing: false,
        error: false,
        reason: '',
        data: null,
    },
    fetchTopStrengthAndTopDevApi: {
        isProcessing: false,
        error: false,
        reason: '',
        data: null,
    },

    fetchRaterHeatmapApi: {
        isProcessing: false,
        error: false,
        reason: '',
        data: null,
    },

    // getRaterHeatmap with isTrendComparison: true — the trend heatmap.
    fetchTrendRaterHeatmapApi: {
        isProcessing: false,
        error: false,
        reason: '',
        data: null,
    },

    fetchBenchmarkKpiTilesApi: {
        isProcessing: false,
        error: false,
        reason: '',
        data: null,
    },

    fetchSelfVsOthersApi: {
        isProcessing: false,
        error: false,
        reason: '',
        data: null,
    },

    // getSelfVsOthers with isTrendComparison — What moved most.
    fetchTrendSelfVsOthersApi: {
        isProcessing: false,
        error: false,
        reason: '',
        data: null,
    },

    // getTopStrengthTopDev with isTrendComparison — Strengths and growth movement.
    fetchTrendTopStrengthAndTopDevApi: {
        isProcessing: false,
        error: false,
        reason: '',
        data: null,
    },

    fetchDistributionStripApi: {
        isProcessing: false,
        error: false,
        reason: '',
        data: null,
    },

    fetchRankDeltaApi: {
        isProcessing: false,
        error: false,
        reason: '',
        data: null,
    },

    fetchCommentsAndGistApi: {
        isProcessing: false,
        error: false,
        reason: '',
        data: null,
        // Id of the most recently dispatched fetch (initial or dropdown-driven
        // scope re-fetch) — lets the reducer drop a response that resolves
        // after a newer request has already been issued.
        latestRequestId: null,
    },

    fetchOrgRaterGroupsApi: {
        isProcessing: false,
        error: false,
        reason: '',
        data: null,
    },

    fetchBenchmarkTaxonomyApi: {
        isProcessing: false,
        error: false,
        reason: '',
        data: null,
    },

    fetchSurveyLists: {
        isProcessing: false,
        error: false,
        reason: '',
        data: null,
    },

    // Cascading Category / Sub-Category / Behavior drill-down for the Sample
    // Comments section. categoryKey/subKey are org-specific taxonomy node
    // values (from fetchBenchmarkTaxonomyApi), so they start empty and
    // SampleComments fills in the first category/sub-category once the
    // taxonomy loads.
    sampleCommentsFilters: {
        categoryKey: '',
        subKey: '',
        behaviorKey: 'all',
    },

    fetchBenchmarkAlignmentScoreApi: {
        isProcessing: false,
        error: false,
        reason: '',
        data: null,
    },

    fetchProjectComparisonApi: {
        isProcessing: false,
        // True only while the load that builds the section from nothing is in
        // flight; a search reload sets isProcessing alone.
        isInitialLoading: false,
        isLoadingMore: false,
        error: false,
        reason: '',
        searchText: '',
        hasMore: false,
        totalAllLeaders: 0,
        // Size of this list with no search over it, from the load that built it;
        // null until one reports it. 0 means searching it can only come back
        // empty, so the request is skipped.
        baseListTotal: null,
        data: [],
    },

    // Same endpoint with listType "notCompared" — see the fetchProjectComparison reducer helper.
    fetchProjectNotComparedApi: {
        isProcessing: false,
        isInitialLoading: false,
        isLoadingMore: false,
        error: false,
        reason: '',
        searchText: '',
        hasMore: false,
        totalLeaders: null,
        totalAllLeaders: 0,
        baseListTotal: null,
        data: [],
    },

    // Sticky (per fetch cycle) flag: flips to true the first time ANY
    // visualization API response comes back with a `scope` reporting the
    // leader-count gate isn't met (leaderCount < leaderGateMin, default 10).
    // Reset to false when the next fetch starts, so a re-applied filter is
    // re-evaluated; within a batch a later non-gated response can't clear it.
    isLeaderGateNotMet: false,
    // Counts captured from that first gated scope, used to build the notice
    // ({ completedSelfCount, leaderGateMin }); null until/unless the gate trips.
    leaderGateScope: null,
    isTrendComparison: false,

    // True while everything the trend view shows was fetched for the filters
    // currently applied. Apply sets it false; until then, turning the
    // comparison off and on again reuses what's already in the store.
    isTrendDataFetched: false,

    // The same for the plain visualizations. Apply only fetches the side the
    // comparison toggle is showing, so the other side stays false until the
    // toggle brings it back on screen and it fetches then.
    isBenchmarkDataFetched: false,

    // How each compared participant is paired with an earlier 360. Lives here
    // rather than in ComparisonView so toggling the comparison off and on
    // doesn't lose it. `matchMode` is 'previous' | 'first' (MATCH_MODES in
    // TrendComparison/constants); `baselineOverrides` is
    // { [currentProjectId]: baselineProjectId } for the rows picked by hand —
    // both sides are project ids, keyed by the leader's current 360, e.g.
    // { "1gj6b2mknnsd73": "k1f8m3cwnumq" }. `applied` is the pairing the results are
    // built from — edits move ahead of it, Apply promotes, Discard rolls back.
    trendPairing: {
        matchMode: 'previous',
        baselineOverrides: {},
        applied: {
            matchMode: 'previous',
            baselineOverrides: {}
        }
    }

});